import React from "react";
import { OfferScrollButton } from "./OfferScrollButton";
import { heroImage } from "../data/content";
export function Hero() {
  return <section className="pb-14 pt-10 text-center sm:px-5 sm:pb-20 sm:pt-16" data-id="element-68" data-mp="eilfp9itz3f5">
      <p className="flex items-center justify-center gap-3 px-4 text-[10px] font-semibold tracking-[0.2em] text-gold sm:gap-4 sm:text-sm sm:tracking-[0.3em]" data-id="element-69" data-mp="9luxogngtxr3">
        <span className="hidden h-px w-8 bg-gold sm:block" aria-hidden data-id="element-70" data-mp="129h5y27n1qka" />
        LA MÉTHODE COMPLÈTE POUR PROFESSEURS DE GUITARE
      </p>
      <h1 className="mx-auto mt-5 max-w-5xl px-4 font-display text-[40px] uppercase leading-[0.95] text-cream sm:mt-6 sm:text-7xl lg:text-[84px]" data-id="element-71" data-mp="xbfht2vcv11y">
        Tout votre trimestre de cours de guitare,
        <span className="block text-gold" data-id="element-72" data-mp="nb6mrsd3nlo5">prêt à enseigner.</span>
      </h1>

      <img src={heroImage} alt="Le pack Le Maître de la Guitare : le livre théorique, le livre pratique et les 5 bonus offerts" className="mx-auto mt-8 w-full max-w-5xl sm:mt-12 sm:rounded-3xl sm:border sm:border-line" data-id="element-73" data-mp="3d21t5zvq8oos" />

      <div className="px-4" data-id="element-74" data-mp="3j9alrqbghebh">
        <OfferScrollButton className="mt-8 w-full sm:mt-10 sm:w-auto" data-id="element-75" data-mp="3o7lv7zxu9mt6" />
        <p className="mt-3 text-xs text-mute sm:text-sm" data-id="element-76" data-mp="3o5j41cky9nmv">PDF envoyés par e-mail · Paiement unique · Garantie 10 jours</p>
      </div>
    </section>;
}